export default {
  bottomBtn: {
    width: '45%',
    typography: 'body1',
    p: '1rem',
    color: '#fff',
    borderRadius: '.6rem',
    fontWeight: '500',
    backgroundColor: 'primary.main',
    '&:hover': {
      backgroundColor: 'primary.main'
    }
  }
};
